const today = () => new Date().toISOString().slice(0, 10);

export const MarkFormFields = ({ form, set, setDayType, search, setSearch }) => (
  <div className="flex flex-wrap items-end gap-3">
    <div>
      <label className="text-xs font-semibold text-stone-500">Date</label>
      <input type="date" required max={today()} value={form.date} onChange={set("date")} data-testid="mark-attendance-date-input"
        className="mt-1 block min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white" />
    </div>
    <div>
      <label className="text-xs font-semibold text-stone-500">Day type</label>
      <select value={form.half_day ? "half" : "full"} onChange={setDayType} data-testid="mark-attendance-daytype-select"
        className="mt-1 block min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white">
        <option value="full">Full day</option>
        <option value="half">Half day</option>
      </select>
    </div>
    <div>
      <label className="text-xs font-semibold text-stone-500">Check-in</label>
      <input type="time" required value={form.check_in} onChange={set("check_in")} data-testid="mark-attendance-in-input"
        className="mt-1 block min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white" />
    </div>
    <div>
      <label className="text-xs font-semibold text-stone-500">Check-out (optional)</label>
      <input type="time" value={form.check_out} onChange={set("check_out")} data-testid="mark-attendance-out-input"
        className="mt-1 block min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white" />
    </div>
    <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search employees…" data-testid="mark-attendance-search"
      className="min-h-[44px] px-3 rounded-lg border border-stone-300 flex-1 min-w-[160px]" />
  </div>
);
